import { put, takeLatest, call } from 'redux-saga/effects';

import * as actions from './actions';
import * as types from './types';
import * as service from './service';

function* fetchOutreachPage() {
    try {
        const data = yield call(service.fetchOutreachPage);

        yield put(actions.fetchOutreachPageSuccess(data));
    } catch (error) {
        yield put(actions.fetchOutreachPageError(error.message));
    }
}

export default function* appSaga() {
    yield takeLatest(types.FETCH_OUTREACH_PAGE, fetchOutreachPage);
}
